'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _element = require('./element');

var _element2 = _interopRequireDefault(_element);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var styles = {
  wrapper: {
    display: 'flex',
    marginTop: '30px',
    fontFamily: '"Gotham SSm A", "Gotham SSm B"',
    fontWeight: 700,
    '@media (max-width: 767px)': {
      marginTop: '60px'
    }
  },
  number: {
    margin: '0 45px',
    fontSize: '20px',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    padding: '8px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      width: '40px',
      height: '40px',
      fontSize: '24px',
      margin: '0 10px 0 0',
      color: '#fff',
      background: '#0099ff',
      border: 'none'
    }
  }
};

function Node(_ref) {
  var number = _ref.number,
      numberOfAnimations = _ref.numberOfAnimations,
      title = _ref.title,
      paragraph = _ref.paragraph,
      imgUrl = _ref.imgUrl,
      mobile = _ref.mobile;

  var element = _react2["default"].createElement(_radium.StyleRoot, null, _react2["default"].createElement(_element2["default"].component, {
    number: number,
    title: title,
    paragraph: paragraph,
    imgUrl: imgUrl
  }));

  var leftElement = number % 2 !== 0 ? element : _react2["default"].createElement('div', {
    style: {
      width: '300px'
    }
  });
  var rightElement = number % 2 === 0 ? element : _react2["default"].createElement('div', {
    style: {
      width: '300px'
    }
  });
  return _react2["default"].createElement('div', {
    style: styles.wrapper
  }, mobile ? null : leftElement, _react2["default"].createElement('div', {
    'data-aos': 'blue',
    'data-aos-offset': 300,
    style: styles.number
  }, number), mobile ? element : rightElement);
}

var component = (0, _radium2["default"])(Node);
exports["default"] = {
  component: component
};